// extracted by mini-css-extract-plugin
export default {"cls1":"VeloNotification-CloseContainer_cls1__FdS+G","cls2":"VeloNotification-CloseContainer_cls2__hke6V VeloNotification-CloseContainer_cls1__FdS+G"};